import Roof from './roof.js'
let text = window.text; // We depend on global localization

export default class DutchGableRoof extends Roof {
  constructor(r,p) {
    super(r,p)

    this.inputs = [
      {
        name: "length",
        title: text.length
      },
      {
        name: "width",
        title: text.width
      },
      {
        name: "height",
        title: text.height,
        alternatives:{
          names: ["angle"],
          convertTo: function(propertyName, height, values){
            if (propertyName == "height"){
              return height;
            }
            return Roof.angle(height,values["width"])*Roof.radianToDegree();
          },
          convertFrom: function(propertyName, propertyValue, values){
            if (propertyName == "height"){
              return propertyValue;
            }
            let angle = propertyValue*Roof.degreeToRadian();
            return Roof.angleToHeight(values["width"], angle);
          },
        },
      },
      {
        name: "lend",
        title: text.lend
      },
/*      {
        name: "wend",
        title: text.wend
      },
*/
      {
        name: "hend",
        title: text.hend,
        alternatives:{
          names: ["angleend"],
          convertTo: function(propertyName, height, values){
            if (propertyName == "hend"){
              return height;
            }
            return Roof.angle(height,values["lend"]*2)*Roof.radianToDegree();
          },
          convertFrom: function(propertyName, propertyValue, values){
            if (propertyName == "hend"){
              return propertyValue;
            }
            let angle = propertyValue*Roof.degreeToRadian();
            return Roof.angleToHeight(values["lend"]*2, angle);
          },
        },
      },
    ]

    this.name = text.rDutch
    this.description = text.rdDutch
  }

	pipes() {
		let i = this.props
		return [i.length, i.length, i.width, i.width]
  }
  
  vindski() {
    let topAngle = Roof.angle(this.props.height,this.props.lend*2);
    let topHeight = this.props.height - this.props.hend;
    return 4 * topHeight/Math.sin(topAngle);
  }

  mone() {
    let topLength = this.props.length - 2*this.props.lend;

    let w = this.props.width/2;
    let tan_theta = this.props.height/w;
    let wend = (w - this.props.hend/tan_theta)*2;
    let hlow = this.props.hend;
    // Distance from outer to inner short side
    let ymid = w - wend/2;
    // width to inner side in its flat system
    let we = Math.sqrt(ymid*ymid + hlow*hlow)
    let sideLength = Math.sqrt(this.props.lend * this.props.lend, we*we)
    return topLength + 4*sideLength;
  }

  getHeight(){
    return this.props.height;
  }

  // Angle in degrees
  angleToHeight(angle){
    //return Math.tan(angle/180*Math.PI)*this.props.width/2.0;
    return Roof.angleToHeight(this.props.width, angle);
  }

  angleendToHeightend(angleend){
    return Roof.angleToHeight(this.props.lend*2, angleend);
    //return Math.tan(angleend)*this.props.lend;
  }

  topatches() {
    /* // TODO>might be wrong
    // If angle instead of height
    let arad = Math.PI*this.props.angle/180
    let height = Math.tan(arad)*w;
    let hlow = height - this.props.height
    // Width to inner side in its flat system
    let le = hlow/Math.sin(arad)
    let we = Math.sqrt(hlow*hlow + this.props.endl*this.props.endl)
*/

    let w = this.props.width/2;

    let tan_theta = this.props.height/w;
    let wend = (w - this.props.hend/tan_theta)*2;


    // If height used
    let height = this.props.height;
    let hlow = this.props.hend;
    // Distance from outer to inner short side
    let ymid = w - wend/2;
    // Length to inner side in its flat system
    let le = Math.sqrt(this.props.lend*this.props.lend + hlow*hlow)
    // width to inner side in its flat system
    let we = Math.sqrt(ymid*ymid + hlow*hlow)
    // Width of inner side
    // Width of patch in flat system
    let wFlatMain = Math.sqrt(height*height+w*w);



    // Width and Length of end in it's flat system

    let patches = [
      // Main front patch
      this.fromarr(
        0,0,
        1000*this.props.lend,1000*we,
        //1000*this.props.endl,1000*w,
        1000*this.props.lend,1000*wFlatMain,
        //1000*(this.props.length-this.props.endl), 1000*w,
        1000*(this.props.length-this.props.lend), 1000*wFlatMain,
        1000*(this.props.length-this.props.lend), 1000*we,
        1000*this.props.length, 0
      ),
      // Opposite front patch
      this.fromarr(
        0,0,
        1000*this.props.lend,1000*we,
        //1000*this.props.endl,1000*w,
        1000*this.props.lend,1000*wFlatMain,
        //1000*(this.props.length-this.props.endl), 1000*w,
        1000*(this.props.length-this.props.lend), 1000*wFlatMain,
        1000*(this.props.length-this.props.lend), 1000*we,
        1000*this.props.length, 0
      ),
      // Front short side
      this.fromarr(
        0,0,
        1000*ymid, 1000*le,
        1000*(this.props.width-ymid), 1000*le,
        1000*this.props.width, 0
      ),
      // Opposite short patch
      this.fromarr(
        0,0,
        1000*ymid, 1000*le,
        1000*(this.props.width-ymid), 1000*le,
        1000*this.props.width, 0
      ),
    ];
    return patches
  }

  patchtransforms() {
    /*
    let arad = Math.PI*this.props.angle/180
    let w = this.props.width/2;
    let height = Math.tan(arad)*w;
    let hlow = height - this.props.height
    // Width to inner side
    let ymid = hlow/Math.sin(arad)
    // Width and Length of end in it's flat system
    let we = Math.sqrt(hlow*hlow + this.props.endl*this.props.endl)
    let le = ymid
  */
    let w = this.props.width/2;

    let tan_theta = this.props.height/w;
    let wend = (w - this.props.hend/tan_theta)*2;

    // If height used
    let height = this.props.height;
    let hlow = this.props.hend;
    // Distance from outer to inner short side
    let ymid = w - wend/2;
    // Length to inner side in its flat system
    let le = Math.sqrt(this.props.lend*this.props.lend + hlow*hlow)
    // width to inner side in its flat system
    let we = Math.sqrt(ymid*ymid + hlow*hlow)
    // Width of inner side
    //let we = wend;
    // Width of patch in flat system
    let wFlatMain = Math.sqrt(height*height+w*w);


    let off = 1000*this.props.width/20
    let ret = [
      {
        t: [-this.props.length/2*1000, -wFlatMain*1000-off],
        r: [0, 0, 0],
      },
      {
        t: [-this.props.length/2*1000, -wFlatMain*1000-off],
        r: [180, 0, 0],
      },
      {
        t: [-1000*w-1000*(this.props.length/2-this.props.lend), -1000*le-2*off],
        r: [-90, -1000*(this.props.length/2-this.props.lend), 0],
      },
      {
        t: [-1000*w+1000*(this.props.length/2-this.props.lend), -1000*le-2*off],
        r: [90, 1000*(this.props.length/2-this.props.lend), 0],
      },
    ]
    return ret;
  }

  validateInput(inputs){
    if (inputs == undefined){
      return undefined;
    }
    let ret = {}
    let hasError = false;
    /*
    if (inputs.wend > inputs.width){
      ret["wend"] = text.errWidthEnd
      hasError = true;
    }
    */
    if (inputs.lend > inputs.length/2){
      ret["lend"] = text.errLengthEnd
      hasError = true 
    }
    if (inputs.hend > inputs.height){
      ret["hend"] = text.errHeightEnd;
      hasError = true;
    }
    if(hasError){
      return ret;
    }
    return undefined;
  }

}



// WEBPACK FOOTER //
// ./roofs/dutchgableroof.js